import { Routes } from '@angular/router';
import { ErpComponent } from '../components/layout/erp/erp.component';

export const content: Routes = [
  {
    path: 'initial',
    loadChildren: () => import('../../components/initial/initial.module').then(m => m.InitialModule),
    data: {
      breadcrumb: "Configuracion Inicial"
    }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {
      breadcrumb: "Dashboard"
    }
  },
  {
    path: 'tablatest',
    loadChildren: () => import('../../netsolinlibrerias/objetotabla/detail-tabla/detail-tabla.module').then(m => m.DetailTablaModule),
    // data: {
    //   breadcrumb: "Configuracion Inicial"
    // }
  },
  {
    path: 'cartera',
    loadChildren: () => import('../../components/cartera/cartera.module').then(m => m.CarteraModule),
    data: {
      breadcrumb: "Cartera"
    }
  },
  {
    path: 'personas',
    loadChildren: () => import('../../components/personas/personas.module').then(m => m.PersonasModule),
    data: {
      breadcrumb: "Personas"
    }
  },
  {
    path: 'up',
    loadChildren: () => import('../../components/unidad-privada/unidad-privada.module').then(m => m.UnidadPrivadaModule),
    data: {
      breadcrumb: "Personas"
    }
  },
  {
    path: 'home-cercanos',
    loadChildren: () => import('../../components/home/home.module').then(m => m.HomeModule),
    data: {
      breadcrumb: "Inicio"
    }
  },
  {
    path: 'sample',
    loadChildren: () => import('../../components/sample/sample.module').then(m => m.SampleModule)
  },
  // {
  //   path: 'erp',
  //   component: ErpComponent,
  //   data: {
  //     breadcrumb: "ERP"
  //   }
  // },
  {
    path: '',
    loadChildren: () => import('../../components/grupos/grupos.module').then(m => m.GruposModule),
    data: {
      breadcrumb: "Grupos"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../components/activos/activos.module').then(m => m.ActivosModule),
    data: {
      breadcrumb: "Activos"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../components/sedes/sedes.module').then(m => m.SedesModule),
    data: {
      breadcrumb: "Sedes"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../components/location/location.module').then(m => m.LocationModule),
    data: {
      breadcrumb: "Localizacion"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../objetosfb/manobjetosfb.module').then(m => m.ManobjetosFBModule),
    data: {
      breadcrumb: "Mantenimiento de Objetos Firebase"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../objetosnetsolin/manobjetosnetsolin.module').then(m => m.ManobjetosNetsolinModule),
    data: {
      breadcrumb: "Mantenimiento de Objetos Netsolin"
    }
  },
  {
    path: '',
    loadChildren: () => import('../../administracion/administracion.module').then(m => m.AdministracionModule),
    data: {
      breadcrumb: "Administracion"
    }
  },
  {
    // loadChildren: () => import('../../mantablasbasicas/mantablasbasicas.module').then(m => m.MantablasbasicasModule),

    path: '',
    loadChildren: () => import('../../mantablasbasicas/netsolin.mantablas.module').then(m => m.NetsolinMantablasModule),
    data: {
      breadcrumb: "Mantenimiento de tablas netsolin"
    }
  },
  // {
  //   path: '',
  //   loadChildren: () => import('../../modulos/crm/crm.module').then(m => m.CrmModule),
  //   data: {
  //     breadcrumb: "Mantenimiento de tablas netsolin"
  //   }
  // },
  {
    path: '',
    loadChildren: () => import('../../modulos/contabilidad/contab.module').then(m => m.ContabModule),
    data: {
      breadcrumb: "Modulo Contable "
    }
  },
  {
    loadChildren: () => import('../../components/class/asset-classes.module').then(m => m.AssetClassesModule),
    data: {
      breadcrumb: "Assets classes"
    }
  },
  // {
  //   path:'pageC',
  //   loadChildren: () => import('../../components/page-creator/page-creator.module').then(m => m.PageCreatorModule),
  //   data: {
  //     breadcrumb: "Assets classes"
  //   }
  // }
];
